import i18n from 'src/locales/i18n';

export const LIMITE_ATIVAS = 8;
export const LIMITE_QUALIF = 6;

// NOTA i18n: este arquivo exporta DADOS de módulo (CATALOGO e derivados),
// consumidos fora de componentes React — por isso usa a instância singleton do
// i18next em vez de useTranslation(), mesmo padrão do catálogo do imobiliário e
// de src/layouts/chats/NavConfig.js. Trade-off assumido: os textos são
// resolvidos uma única vez no carregamento do módulo e não reagem a troca de
// idioma sem reload.
const t = (key, defaultValue) => i18n.t(`settings:aiAgents.ecommerce.catalog.${key}`, defaultValue);

// Catálogo de perguntas do fluxo de coleta do varejo.
//
// Entradas com `spinField` participam da qualificação: é o identificador que o
// agente usa para saber qual campo aquela pergunta preenche.
//
// ATENÇÃO: a lista de `spinField` precisa ficar sincronizada com
// lais-ai/src/agents/ecommerce/identity.js → CATALOG_TO_SPIN_FIELD.
// Alterar aqui exige alterar lá também (ou vice-versa).
export const CATALOGO = [
    // ─── Perguntas de qualificação (alimentam a busca no catálogo) ─────
    {
        id: 'intencao',
        titulo: t('intencaoTitulo', 'Intenção do contato'),
        descricao: t('intencaoDescricao', 'Se o cliente quer comprar, tirar dúvida ou falar de um pedido existente.'),
        icon: 'mdi:help-circle-outline',
        spinField: 'intencao',
        defaultScript: t('intencaoScript', 'Você está procurando algum produto ou precisa de ajuda com um pedido?'),
    },
    {
        id: 'categoria',
        titulo: t('categoriaTitulo', 'Categoria de interesse'),
        descricao: t('categoriaDescricao', 'Que tipo de produto o cliente procura.'),
        icon: 'mdi:shape-outline',
        spinField: 'categoria',
        defaultScript: t('categoriaScript', 'Que tipo de produto você procura?'),
    },
    {
        id: 'produto-alvo',
        titulo: t('produtoAlvoTitulo', 'Produto específico'),
        descricao: t('produtoAlvoDescricao', 'Quando o cliente já sabe o que quer, ou tem o código do produto.'),
        icon: 'mdi:package-variant-closed',
        spinField: 'produto',
        defaultScript: t('produtoAlvoScript', 'Já sabe qual produto quer? Se tiver o código, pode mandar.'),
    },
    {
        id: 'variacao',
        titulo: t('variacaoTitulo', 'Variação (cor, tamanho, modelo)'),
        descricao: t('variacaoDescricao', 'Atributos que restringem a busca no catálogo.'),
        icon: 'mdi:palette-outline',
        spinField: 'atributos',
        defaultScript: t('variacaoScript', 'Alguma preferência de cor, tamanho ou modelo?'),
    },
    {
        id: 'faixa-preco',
        titulo: t('faixaPrecoTitulo', 'Faixa de preço'),
        descricao: t('faixaPrecoDescricao', 'Quanto o cliente pretende gastar.'),
        icon: 'mdi:cash-multiple',
        spinField: 'preco',
        // Vocabulário deliberado: a assistente nunca diz "orçamento".
        defaultScript: t('faixaPrecoScript', 'Qual valor você está disposto a pagar?'),
    },
    {
        id: 'quantidade',
        titulo: t('quantidadeTitulo', 'Quantidade'),
        descricao: t('quantidadeDescricao', 'Quantas unidades. Volume alto costuma indicar atacado.'),
        icon: 'mdi:numeric',
        spinField: 'quantidade',
        defaultScript: t('quantidadeScript', 'Quantas unidades você precisa?'),
    },
    {
        id: 'finalidade',
        titulo: t('finalidadeTitulo', 'Uso próprio, presente ou revenda'),
        descricao: t('finalidadeDescricao', 'Muda o discurso e o ticket sugerido.'),
        icon: 'mdi:gift-outline',
        spinField: 'finalidade',
        defaultScript: t('finalidadeScript', 'É para uso próprio, presente ou revenda?'),
    },
    {
        id: 'prazo',
        titulo: t('prazoTitulo', 'Urgência'),
        descricao: t('prazoDescricao', 'Para quando o cliente precisa — prioriza itens com estoque.'),
        icon: 'mdi:clock-outline',
        spinField: 'prazo',
        defaultScript: t('prazoScript', 'Para quando você precisa?'),
    },
    {
        id: 'cep',
        titulo: t('cepTitulo', 'CEP de entrega'),
        descricao: t('cepDescricao', 'Necessário para verificar entrega e, no futuro, calcular frete.'),
        icon: 'mdi:map-marker-outline',
        spinField: 'cep',
        defaultScript: t('cepScript', 'Me passa seu CEP para eu verificar a entrega?'),
    },

    // ─── Enriquecimento (não participam da busca) ──────────────────────
    // Sem `spinField`: aparecem com o badge "Referência" e os switches travados,
    // porque o agente não extrai esses campos.
    { id: 'cpf', titulo: t('cpfTitulo', 'CPF'), descricao: t('cpfDescricao', 'Coletar CPF antes de passar ao vendedor.'), icon: 'mdi:card-account-details-outline' },
    { id: 'email', titulo: t('emailTitulo', 'E-mail'), descricao: t('emailDescricao', 'Para envio de comprovante ou nota.'), icon: 'mdi:email-outline' },
    { id: 'possui-cadastro', titulo: t('possuiCadastroTitulo', 'Já é cliente'), descricao: t('possuiCadastroDescricao', 'Se o cliente já comprou antes na loja.'), icon: 'mdi:account-check-outline' },
    { id: 'forma-pagamento-preferida', titulo: t('formaPagamentoTitulo', 'Forma de pagamento preferida'), descricao: t('formaPagamentoDescricao', 'Como o cliente prefere pagar.'), icon: 'mdi:credit-card-outline' },
    { id: 'aceita-similar', titulo: t('aceitaSimilarTitulo', 'Aceita produto similar'), descricao: t('aceitaSimilarDescricao', 'Se topa uma alternativa quando o item exato está sem estoque.'), icon: 'mdi:swap-horizontal' },

    // ─── Híbrida: qualifica E tem opções configuráveis ────────────────
    {
        id: 'canal-contato',
        titulo: t('canalContatoTitulo', 'Como nos conheceu'),
        descricao: t('canalContatoDescricao', 'Origem do contato — útil para atribuição de marketing.'),
        icon: 'mdi:bullhorn-outline',
        spinField: 'canal_contato',
        opcoesConfiguraveis: true,
        // NÃO traduzir os `label`: são copiados verbatim para a config do agente
        // e podem ser repassados a integrações externas como origem do lead.
        opcoesDefault: [
            { label: 'Instagram', value: 'instagram' },
            { label: 'Facebook', value: 'facebook' },
            { label: 'Google', value: 'google' },
            { label: 'Indicação', value: 'indicacao' },
            { label: 'Loja física', value: 'loja-fisica' },
            { label: 'Site', value: 'site' },
            { label: 'Marketplace', value: 'marketplace' },
        ],
        defaultScript: t('canalContatoScript', 'Só pra eu te atender melhor: como você chegou até a gente? 😊'),
    },
];

export const CATALOGO_BY_ID = CATALOGO.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
}, {});

export const CATALOGO_BY_SPIN_FIELD = CATALOGO.reduce((acc, item) => {
    if (item.spinField) acc[item.spinField] = item;
    return acc;
}, {});

export const SPIN_CATALOG_IDS = new Set(
    CATALOGO.filter((item) => item.spinField).map((item) => item.id)
);
